// removed by extract-text-webpack-plugin
module.exports = {"SideDrawer":"SideDrawer__SideDrawer__3ckot","Open":"SideDrawer__Open__IteR9","Close":"SideDrawer__Close__mRjY3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Sidedrawer/SideDrawer.css
// module id = 81
// module chunks = 3